import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-genesys-chat-message-typing-indicator',
  templateUrl: './genesys-chat-message-typing-indicator.component.html',
  styleUrls: ['./genesys-chat-message-typing-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenesysChatMessageTypingIndicatorComponent {
}
